<nb-select fullWidth
           [(selected)]="value"
           [disabled]="isDisabled">
  <nb-option *ngIf="showEmptyOption" [value]="">Alle</nb-option>
  <nb-option [value]="NotificationType.InspectionComment">Rundgangskommentar</nb-option>
  <nb-option [value]="NotificationType.Maintenance">Wartung</nb-option>
  <nb-option [value]="NotificationType.BuildingApplication">Gebäudeantrag</nb-option>
</nb-select>
